import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../PrivacyTab.module.scss';

interface SidebarSection {
    id: string;
    labelKey: string;
}

interface SidebarGroup {
    labelKey: string;
    sections: SidebarSection[];
}

type Props = {
    activeSectionId: string;
    onSectionClick: (sectionId: string) => void;
};

const PrivacySidebar: React.FC<Props> = ({ activeSectionId, onSectionClick }: Props) => {
    const { t } = useTranslation();

    const groups: SidebarGroup[] = [
        {
            labelKey: 'privacy.section_drivers',
            sections: [
                { id: 'sec-drivers-privacy', labelKey: 'privacy.drivers_privacy' },
                { id: 'sec-drivers-history', labelKey: 'privacy.drivers_history' },
                { id: 'sec-anonymize-driver', labelKey: 'privacy.section_anonymize' },
                { id: 'sec-anonymize-history', labelKey: 'privacy.anonymize_history_title' },
            ],
        },
        {
            labelKey: 'privacy.section_assets',
            sections: [
                { id: 'sec-vehicles-privacy', labelKey: 'privacy.vehicles_privacy' },
                { id: 'sec-vehicles-history', labelKey: 'privacy.vehicles_history' },
                { id: 'sec-delete-vehicle', labelKey: 'privacy.section_delete' },
                { id: 'sec-delete-history', labelKey: 'privacy.deletion_history_title' },
            ],
        },
    ];

    return (
        <aside className={styles.sidebar}>
            {groups.map(group => (
                <React.Fragment key={group.labelKey}>
                    <div className={styles.sidebarGroupLabel}>
                        {t(group.labelKey as any) as string}
                    </div>
                    {group.sections.map(section => (
                        <div
                            key={section.id}
                            className={`${styles.sidebarItem} ${activeSectionId === section.id ? styles.sidebarItemActive : ''}`}
                            onClick={() => onSectionClick(section.id)}
                        >
                            <div className={styles.sidebarDot} />
                            {t(section.labelKey as any) as string}
                        </div>
                    ))}
                </React.Fragment>
            ))}
        </aside>
    );
};

export default PrivacySidebar;
